export function classNames(
  ...classNames: (string | null | undefined)[]
): string {
  return classNames.filter((value) => value).join(" ");
}
